import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BranchesService {

    constructor(private _HttpClient: HttpClient) { }

    getBranchesDetails(id: string): Observable<any[]> {
        return this._HttpClient.get<any[]>(environment.baseUrl + `branch/${id}`)
    }

    getHCBranchesDetails(id: string): Observable<any[]> {
        return this._HttpClient.get<any[]>(environment.baseUrl + `branch/healthcare/${id}`)
    }

    createBranch(formData: any): Observable<any[]> {
        return this._HttpClient.post<any[]>(environment.baseUrl + 'branch/new', formData);
    }

    updateBranch(id:any, newData: any):Observable<any[]>  {
      return  this._HttpClient.put<any[]>(environment.baseUrl + `branch/${id}`, newData);
    }

    deleteBranch(id: string):Observable<any[]> {
       return this._HttpClient.delete<any[]>(environment.baseUrl + `branch/${id}`);
    }

}
